import script from "./LoginScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginScreen.vue?vue&type=script&setup=true&lang=js"

import "./LoginScreen.vue?vue&type=style&index=0&id=f1002b88&scoped=true&lang=css"

import exportComponent from "/home/adelaplace/PycharmProjects/pumping_tool_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1002b88"]])

export default __exports__